import { render, staticRenderFns } from "./CandleTemplates.vue?vue&type=template&id=0f53a7ce&scoped=true"
import script from "./CandleTemplates.vue?vue&type=script&lang=js"
export * from "./CandleTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f53a7ce",
  null
  
)

export default component.exports